import * as integration from './integration'
import * as mock from './mock'
import { env } from '@/config/env'

export * from './types'

const selectedModule = env.USE_MOCKS ? mock : integration

export const {
  getPosts,
  getCategories,
  getPost,
  getAllArticles,
  getPostsSlugsByProperty,
} = selectedModule
